import Vue from 'vue'
import VueI18n from 'vue-i18n';
import language from './language';
import { isWx,isApp} from '@/utils/const';

Vue.use(VueI18n);

export const EN = 'en';
export const ZH = 'zh-cn';
export const ZH_HK = 'zh-hk';
export const ZH_HANT = 'zh-hant';
export const LANGUAGE_LIST = [ZH, EN, ZH_HK];

const defaultLanguage = ZH

const i18n = new VueI18n({
	locale: defaultLanguage,
	fallbackLocale: defaultLanguage,
	messages: language,
	silentTranslationWarn: true
})
i18n.EN = EN;
i18n.ZH = ZH;
i18n.ZH_HK = ZH_HK;
const langMap = {
	'zh-cn': ZH, 
	'zh-hk': ZH_HK,
	'en': EN,
	"en-us": EN,
	'zh-hant':ZH_HANT,
	'zh-tw': ZH_HK,

	"zh_cn": ZH,
	"zh_hk": ZH_HK,
	'zh_tw': ZH_HK,
	
 };

export function changeLocaleLang(lang) {
	// 关于zh-hk localStorage 存zh-hant i18n实例里面存zh-hk

	const language = lang || (/lang=([a-z_-]+[^&])/i.test(location.search) && RegExp.$1) || window.localStorage.getItem('Language') || (isWx ? navigator.userAgent.match(/Language\/([a-z_-]+[^&])/i)?.[1] : navigator.language) || defaultLanguage;
	// 小写，并移除前后空格
	const lowerCaseLang = language?.toLowerCase()?.trim();
	let locale = langMap[lowerCaseLang] || defaultLanguage;
	// i18n实例 zh-hant 转换为 zh-hk
	locale = locale === ZH_HANT ? ZH_HK : locale;
	i18n.locale = isApp ? defaultLanguage : locale;

	// storage 里面存zh-hant
	const storageLang = locale ===  ZH_HK ? ZH_HANT : locale;
	if(lang) {
		window.localStorage.setItem('Language', storageLang);
	}
}

changeLocaleLang();

export const translate = (key) => {
    // 使用 te 方法检查是否能够匹配到对应键值
	const locale = i18n.locale
    const hasKey = i18n.te(key, locale)
    const translatedStr = i18n.t(key)
    if (hasKey) {
        return translatedStr
    }
    return key
}

/** 区分不同语种下的升降色值表达 */
export const computedStockColorByLang = value => {
	const isIncrease = value > 0
	const greenColor = '#30aa5b'
	const redColor = '#fa4646'
	let color;
	if (i18n.locale === ZH) {
		color = isIncrease ? redColor : greenColor
	} else {
		color = isIncrease ? greenColor : redColor
	}
	return {
		'color': color
	}
}

export const languageTypeMap = {
	[ZH]: 0,
	[ZH_HK]: 2,
	[EN]: 1
}
export const getLanguageType = () => languageTypeMap[i18n.locale]

export const languageMap = {
	0: ZH,
	1: EN,
	2: ZH_HK
};
export const getLanguageByType = type => languageMap[type];

export const updatePageMetaByLang = storeId => {
	if (!storeId) return;

	const langKeyMap = {
		slogan: {
			'zh-cn': 'slogan',
			'zh-hk': 'hkSlogan',
			'en': 'enSlogan'
		}
	};

	const irstoreData = convertToKeyValueObject(window.__IRSTORE_CONFIG || {});
	const pickIrstore = irstoreData[storeId] || {};

	let lang = localStorage.getItem('Language');
	lang = lang === ZH_HANT ? ZH_HK : lang;
	const activeLang = LANGUAGE_LIST.includes(lang) ? lang : defaultLanguage;

	const curSlogan = langKeyMap.slogan[activeLang];
	const metaDesc = document.querySelector('meta[name="description"]');
	if (metaDesc) {
		metaDesc.content = pickIrstore[curSlogan] || '';
	}
};

export default i18n;